import { render, staticRenderFns } from "./StandardTextfield.component.vue?vue&type=template&id=56bdf5b8&scoped=true&lang=html&"
import script from "./StandardTextfield.component.vue?vue&type=script&lang=js&"
export * from "./StandardTextfield.component.vue?vue&type=script&lang=js&"
import style0 from "./StandardTextfield.component.vue?vue&type=style&index=0&id=56bdf5b8&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bdf5b8",
  null
  
)

export default component.exports